<template>
  <el-select class="removeReadonly" v-model="lead.status" placeholder="Select">
    <el-option
      v-for="status in statuses"
      :key="status.value"
      :label="status.label"
      :value="status.value">
    </el-option>
  </el-select>
</template>

<script>
import {Lead} from 'src/classes/datamodel.js'
export default {
    name: 'Lead-Status-Input',
    props: {
        lead: { type: Lead, required: true }
    },
    data () {
      return {
        statuses: Lead._status
      }
    }

}
</script>

<style>

</style>